"use client";

import { AnimatePresence, motion } from "motion/react";

interface LoginProgressIndicatorProps {
  active: boolean;
  label: string;
  className?: string;
}

// Custom indeterminate progress bar — the DS ProgressBar only supports
// determinate values (0-100) and has no indeterminate/loading mode.
export function LoginProgressIndicator({
  active,
  label,
  className,
}: LoginProgressIndicatorProps) {
  const containerClass = className
    ? `${className} space-y-2`
    : "space-y-2";

  return (
    <AnimatePresence initial={false}>
      {active && (
        <motion.div
          key="login-progress-indicator"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.2 }}
          className={containerClass}
        >
          <div className="h-1 w-full overflow-hidden rounded-full" style={{ backgroundColor: "var(--color-alias-neutral-light)" }}>
            <motion.div
              className="h-full w-1/2 rounded-full" style={{ backgroundColor: "var(--color-alias-info)" }}
              initial={{ x: "-100%" }}
              animate={{ x: "200%" }}
              transition={{
                repeat: Infinity,
                repeatType: "loop",
                duration: 1.2,
                ease: "easeInOut",
              }}
            />
          </div>
          <p className="text-xs text-center" style={{ color: "var(--color-alias-neutral-dark)" }}>{label}</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
